import styled from "styled-components";
import { Link } from "react-router-dom";

export const Page = styled.main`
  padding: 138px clamp(16px, 5vw, 72px) 80px;
  background: radial-gradient(circle at 85% 8%, rgba(255, 169, 0, 0.16), transparent 25%), ${({ theme }) => theme.color.light};
`;

export const Hero = styled.header`
  max-width: 1180px;
  margin: 0 auto 38px;
`;

export const Eyebrow = styled.p`
  display: inline-flex;
  margin: 0 0 14px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(28, 93, 39, 0.1);
  color: ${({ theme }) => theme.color.green};
  font-size: 14px;
  font-weight: 700;
`;

export const Title = styled.h1`
  max-width: 780px;
  margin: 0;
  font-size: clamp(38px, 6vw, 68px);
  line-height: 1.02;
  letter-spacing: -0.045em;
`;

export const Lead = styled.p`
  max-width: 760px;
  margin: 20px 0 0;
  color: #50544f;
  font-size: 19px;
  line-height: 1.6;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 0.82fr) minmax(0, 1.18fr);
  gap: 24px;
  max-width: 1180px;
  margin: 0 auto;
  align-items: start;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

export const Panel = styled.section`
  min-width: 0;
  padding: clamp(22px, 4vw, 38px);
  border: 1px solid rgba(29, 29, 27, 0.08);
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 22px 65px rgba(24, 53, 30, 0.09);
`;

export const Form = styled.form`
  display: grid;
  gap: 17px;
`;

export const Field = styled.label`
  display: grid;
  gap: 7px;
  font-size: 14px;
  font-weight: 700;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;

export const Hint = styled.span`
  color: #747874;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
`;

export const Input = styled.input`
  width: 100%;
  min-height: 50px;
  padding: 0 15px;
  border: 1px solid ${({ $invalid }) => ($invalid ? "#a62d2d" : "#d8ddd8")};
  border-radius: 14px;
  background: #fbfcfa;
  color: ${({ theme }) => theme.color.black};
  font: inherit;
  &:focus { outline: 3px solid rgba(255, 169, 0, 0.25); border-color: ${({ theme }) => theme.color.orange}; }
`;

export const Select = styled.select`
  width: 100%;
  min-height: 50px;
  padding: 0 15px;
  border: 1px solid #d8ddd8;
  border-radius: 14px;
  background: #fbfcfa;
  color: ${({ theme }) => theme.color.black};
  font: inherit;
`;

export const Error = styled.span`
  color: #a62d2d;
  font-size: 12px;
  font-weight: 500;
`;

export const Submit = styled.button`
  min-height: 54px;
  margin-top: 4px;
  border: 0;
  border-radius: 999px;
  background: ${({ theme }) => theme.color.orange};
  color: ${({ theme }) => theme.color.black};
  font-size: 15px;
  font-weight: 800;
  text-transform: uppercase;
  cursor: pointer;
  &:hover { transform: translateY(-2px); box-shadow: 0 12px 24px rgba(255, 169, 0, 0.28); }
`;

export const ResultHeading = styled.div`
  margin-bottom: 22px;
  h2 { margin: 0; font-size: clamp(26px, 4vw, 38px); }
  p { margin: 6px 0 0; color: #676b67; }
`;

export const Insight = styled.div`
  margin: 18px 0;
  padding: 16px 18px;
  border-left: 5px solid #326ba8;
  border-radius: 14px;
  background: #f1f6fb;
  color: #445148;
  font-size: 14px;
  line-height: 1.5;
  strong { display: block; margin-bottom: 4px; color: ${({ theme }) => theme.color.green}; }
`;

export const ScenarioGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
  @media (max-width: 850px) { grid-template-columns: 1fr; }
`;

export const Scenario = styled.article`
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 17px;
  border: 1px solid #d6e1d8;
  border-top: 5px solid ${({ $rkm, $best, theme }) => ($best ? theme.color.orange : $rkm ? "#326ba8" : "#7d897f")};
  border-radius: 17px;
  background: ${({ $best, $blocked }) => ($blocked ? "#f6f6f4" : $best ? "#fffdf5" : "#fff")};
  box-shadow: 0 8px 24px rgba(23, 61, 29, 0.05);
  h3 { margin: 0; color: ${({ theme }) => theme.color.green}; font-size: 17px; }
  .blocked-title { margin: 15px 0 4px; color: #3f4c42; font-size: 14px; font-weight: 800; line-height: 1.5; }
`;

export const Badge = styled.span`
  align-self: flex-start;
  margin-bottom: 9px;
  padding: 5px 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.color.orange};
  color: #382600;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
`;

export const Availability = styled.span`
  display: grid;
  gap: 4px;
  align-self: flex-start;
  margin: 0 0 9px;
  padding: 7px 9px;
  border-radius: 10px;
  background: #fff0ec;
  color: #8d2d20;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.4;
`;

export const Kicker = styled.span`
  display: block;
  margin-bottom: 7px;
  color: #687269;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .04em;
`;

export const Payment = styled.div`
  margin: 15px 0 3px;
  color: ${({ theme }) => theme.color.green};
  font-size: 27px;
  font-weight: 900;
  small { font-size: 13px; font-weight: 700; color: #687269; }
`;

export const Facts = styled.dl`
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid #e3ebe4;
  div { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; }
  dt { color: #687269; }
  dd { margin: 0; text-align: right; color: #233126; font-weight: 700; }
`;

export const Note = styled.p`
  margin: 13px 0 0;
  color: #58655a;
  font-size: 12px;
  line-height: 1.45;
`;

export const Details = styled.details`
  margin-top: 13px;
  summary { cursor: pointer; color: ${({ theme }) => theme.color.green}; font-size: 12px; font-weight: 800; }
`;

export const TableWrap = styled.div`
  max-width: 100%;
  max-height: 260px;
  margin-top: 10px;
  overflow: auto;
  border: 1px solid #e0e4df;
  border-radius: 12px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  font-size: 11px;
  th, td { padding: 8px 9px; text-align: right; border-bottom: 1px solid #eceeeb; }
  th:first-child, td:first-child { text-align: left; }
  th { position: sticky; top: 0; background: #f3f5f1; }
`;

export const Assumptions = styled.div`
  margin-top: 18px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #eef4ef;
  color: #536056;
  font-size: 13px;
  line-height: 1.5;
  strong { color: ${({ theme }) => theme.color.green}; }
`;

export const Funnel = styled.section`
  margin-top: 22px;
  padding: 20px;
  border: 1px solid #cfe0d2;
  border-top: 5px solid ${({ theme }) => theme.color.green};
  border-radius: 18px;
  background: linear-gradient(135deg, #f4faf4, #fff);
  h3 { margin: 0; color: ${({ theme }) => theme.color.green}; font-size: 21px; }
  p { margin: 7px 0 0; color: #536056; font-size: 14px; line-height: 1.5; }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
`;

export const CTA = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 20px;
  border-radius: 999px;
  background: ${({ theme }) => theme.color.orange};
  color: ${({ theme }) => theme.color.black};
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
`;

export const Secondary = styled.button`
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.color.green};
  border-radius: 999px;
  background: transparent;
  color: ${({ theme }) => theme.color.green};
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
`;

export const Disclaimer = styled.div`
  max-width: 1180px;
  margin: 24px auto 0;
  padding: 22px 24px;
  border-radius: 18px;
  background: rgba(28, 93, 39, 0.07);
  color: #545954;
  h2 { margin: 0 0 8px; font-size: 18px; }
  p { margin: 0; font-size: 13px; line-height: 1.65; }
`;

